import React from "react";
import { Loader2, Play } from "lucide-react";
import { Button } from "@/components/ui/button";

export function RunPanel({ canRun, running, progress, onRun, language = "en" }) {
  const t = language === "nl" ? {
    title: "Run simulatie",
    ready: "Klaar om te starten.",
    disabled: "Upload eerst een ontwerpconcept.",
    running: "Bezig...",
    run: "Run simulatie",
    progress: "Metadata zoeken, payload bouwen, rapport genereren...",
  } : {
    title: "Run simulation",
    ready: "Ready to run.",
    disabled: "Upload a design concept to enable.",
    running: "Running...",
    run: "Run simulation",
    progress: "Searching metadata, building payload, generating report...",
  };
  return (
    <div className="rounded-2xl border border-black/10 bg-white p-5" data-testid="synberry-run-card">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="font-display text-lg font-semibold text-black">8. {t.title}</div>
          <div className="text-xs text-black/60">{canRun ? t.ready : t.disabled}</div>
        </div>
        <Button
          onClick={onRun}
          disabled={!canRun}
          className="rounded-xl bg-[#61CBA3] text-white hover:bg-[#4DAF8B] active:bg-[#3F9777] disabled:opacity-50"
          data-testid="synberry-run-button"
        >
          {running ? (<><Loader2 className="h-4 w-4 mr-2 animate-spin" /> {t.running}</>) : (<><Play className="h-4 w-4 mr-2" /> {t.run}</>)}
        </Button>
      </div>
      {running && (
        <div className="mt-3" data-testid="synberry-run-progress">
          <div className="h-1.5 w-full bg-black/5 rounded-full overflow-hidden">
            <div className="h-full bg-[#61CBA3] transition-[width] duration-200" style={{ width: `${progress}%` }} />
          </div>
          <div className="mt-1 text-xs text-black/60">{t.progress}</div>
        </div>
      )}
    </div>
  );
}
